import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { AuthProvider, UserProvider, LocalizationProvider } from './contexts';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <UserProvider>
        <LocalizationProvider>
          <App />
        </LocalizationProvider>
      </UserProvider>
    </AuthProvider>
  </React.StrictMode>
);
